<template>
    <CRow>
        <CCol sm="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol class="mt-3">
                            <h5>Category Opportunity</h5>
                        </CCol>
                        <CCol>
                            <div class="card-header-actions">
                                <CButton
                                    color="secondary"
                                    class="m-2"
                                    @click="importModal = true"
                                    >Import Opportunity
                                </CButton>
                                <CButton
                                    color="success"
                                    class="m-2"
                                    @click="
                                        addModal = true;
                                        reset();
                                    "
                                    >Add Opportunity
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CModal
                    title="Add category opportunity"
                    :show.sync="addModal"
                    class="addCategoryModal"
                    centered
                    fade
                    size="lg"
                    :closeOnBackdrop="false"
                >
                    <CCol class="clientfilter" v-if="isAdmin === 'sys_admin' || isAdmin === 'group_admin'">
                        <CSelect
                            :options="clientOptions"
                            placeholder="Select a client"
                            :lazy="false"
                            :value.sync="
                                $v.categoryOpportunity.client_id.$model
                            "
                            :isValid="checkIfValid('client_id')"
                            invalidFeedback="Select a client"
                            label="Client"
                            :horizontal="{
                                label: 'col-sm-3',
                                input: 'col-sm-9',
                            }"
                            id="client"
                            :disabled="update == true"
                        />
                    </CCol>
                    <CInput
                        label="Goal Name"
                        type="text"
                        :value.sync="$v.categoryOpportunity.goal_name.$model"
                        horizontal
                        :lazy="false"
                        :isValid="checkIfValid('goal_name')"
                        invalidFeedback="This is a required field"
                    />

                    <CSelect
                        label="Prime Category"
                        horizontal
                        placeholder="Select a prime category"
                        :value.sync="
                            $v.categoryOpportunity.prime_category.$model
                        "
                        :options="primeCategoryOptions"
                        :isValid="checkIfValid('prime_category')"
                        invalidFeedback="Select a valid prime category"
                        :id="`prime-category`"
                        @change="handlePrimeSelect"
                    />

                    <CSelect
                        label="Secondary Category"
                        horizontal
                        placeholder="Select a secondary category"
                        :value.sync="$v.categoryOpportunity.category.$model"
                        :options="secondaryCategoryOptions"
                        :isValid="checkIfValid('category')"
                        invalidFeedback="Select a valid secondary category"
                        :id="`secondary-category`"
                        :disabled="secondaryCategoryOptions.length === 0"
                        @change="handleSecondarySelect"
                    />

                    <CSelect
                        label="Sub Category"
                        horizontal
                        placeholder="Select a sub category"
                        :value.sync="$v.categoryOpportunity.sub_category.$model"
                        :options="subCategoryOptions"
                        :isValid="checkIfValid('sub_category')"
                        invalidFeedback="Select a valid sub category"
                        :id="`sub-category`"
                        :disabled="subCategoryOptions.length === 0"
                    />
                    <CInput
                        type="date"
                        label="Created Date"
                        horizontal
                        placeholder="Enter a created date"
                        :value.sync="$v.categoryOpportunity.created_at.$model"
                        :isValid="checkIfValid('created_at')"
                        invalidFeedback="Enter a valid created date. Created date can't be in the future"
                    />
                    <CInput
                        v-if="!isClientUser"
                        label="Opportunity (%)"
                        type="text"
                        :value.sync="$v.categoryOpportunity.opportunity.$model"
                        horizontal
                        :lazy="false"
                        :isValid="checkIfValid('opportunity')"
                        invalidFeedback="Enter a valid opportunity %"
                        class="opportunity"
                    />
                    <CInput
                        label="Goal (%)"
                        type="text"
                        :value.sync="$v.categoryOpportunity.goal.$model"
                        horizontal
                        :lazy="false"
                        :isValid="checkIfValid('goal')"
                        invalidFeedback="Enter a valid goal %"
                        class="goal"
                    />
                    <br />
                    <CButton
                        type="submit"
                        color="primary"
                        class="m-1"
                        @click="
                            update
                                ? updateCategoryOpportunity()
                                : saveCategoryOpportunity()
                        "
                        :style="{ float: 'right' }"
                        >Submit</CButton
                    >

                    <CButton
                        type="submit"
                        color="secondary"
                        class="m-1"
                        @click="addModal = false"
                        :style="{ float: 'right' }"
                        >Cancel</CButton
                    >
                </CModal>
                <CCardBody>
                    <CRow>
                        <CCol sm="3">
                            <CInput
                                placeholder="Search goal name"
                                :value.sync="searchVal"
                                :lazy="800"
                                horizontal
                            />
                        </CCol>
                        <CCol sm="5"></CCol>
                        <CCol>
                            <CSelect
                                v-if="isSysAdmin || isGroupAdmin"
                                :options="clientList"
                                placeholder="Filter on client"
                                :value.sync="clientFilter"
                                label="Client Filter:"
                                horizontal
                            />
                        </CCol>
                    </CRow>
                    <CDataTable
                        :items="filteredCategoryOpportunityList"
                        :fields="categoryFields"
                        :column-filter="false"
                        :items-per-page="limit"
                        :itemsPerPageSelect="true"
                        hover
                        sorter
                        cleaner
                        @pagination-change="
                            (item) => {
                                limit = item;
                                offset = 0;
                                getCategoryOpportunity();
                            }
                        "
                        ><template #action="{ item, index }">
                            <td class="py-0">
                                <CButton
                                    color="success"
                                    square
                                    size="sm"
                                    class="m-1"
                                    @click="
                                        editCategoryOpportunity(item, index)
                                    "
                                    v-c-tooltip="{
                                        content: 'Edit',
                                        placement: 'bottom',
                                    }"
                                >
                                    <CIcon name="cil-pencil" />
                                </CButton>
                                <CButton
                                    color="danger"
                                    square
                                    size="sm"
                                    class="m-1"
                                    @click="deleteOpportunity(item, index)"
                                    v-c-tooltip="{
                                        content: 'Delete',
                                        placement: 'bottom',
                                    }"
                                >
                                    <CIcon name="cil-x-circle" />
                                </CButton>
                            </td>
                        </template>
                        <template #client_name="{ item }">
                            <td>{{ item.client.name || "" }}</td>
                        </template>
                        <template #prime_category="{ item }">
                            <td>{{ item.prime_category_master.name || "" }}</td>
                        </template>
                        <template #category="{ item }">
                            <td>
                                {{
                                    item.category_master
                                        ? item.category_master.name
                                        : ""
                                }}
                            </td>
                        </template>
                        <template #sub_category="{ item }">
                            <td>
                                {{
                                    item.sub_category_master
                                        ? item.sub_category_master.name
                                        : ""
                                }}
                            </td>
                        </template>
                        <template #opportunity="{ item }">
                            <td>
                                {{ item.opportunity }}
                            </td>
                        </template>
                    </CDataTable>
                    <CRow style="padding-bottom: 20px" v-if="pageCount > 0">
                        <CCol></CCol>
                        <CCol>
                            <CButton
                                color="primary"
                                class="m-2"
                                download="coreui-table-data.csv"
                                target="_blank"
                                :disabled="offset < 1"
                                @click="getPreviousPage"
                                >Previous
                            </CButton>
                            page {{ offset / limit + 1 }} of {{ pageCount }}
                            <CButton
                                color="primary"
                                class="m-2"
                                download="coreui-table-data.csv"
                                target="_blank"
                                :disabled="pageCount === offset / limit + 1"
                                @click="getNextPage"
                                >Next
                            </CButton>
                        </CCol>
                        <CCol> </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </CCol>

        <Confirm
            :handleOperation="handleDeleteOpportunity"
            :modal="chooseFileTypeModal"
            type="delete"
            @close="chooseFileTypeModal = false"
        />

        <Success
            :modal="success.enable"
            :message="success.message"
            @res-handler="success.enable = false"
            @close="success.enable = false"
        />

        <Error
            :modal="error.enable"
            :message="error.message"
            @close="error.enable = false"
        />

        <!-- Import module -->
        <Import
            title="Import category wise opportunity"
            :modal="importModal"
            type="category-wise-opportunity"
            :selectClient="true"
            @close="importModal = false"
        />

        <CElementCover v-if="spinner" :opacity="0.8" />
    </CRow>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";
import { storeData } from "../../store";
import {
    GET_CATEGORY_WISE_OPPORTUNITY,
    INSERT_CATEGORY_WISE_OPPORTUNITY,
    UPDATE_CATEGORY_WISE_OPPORTUNITY,
    DELETE_CATEGORY_WISE_OPPORTUITY,
} from "./categoryQueries";
import _ from "../Utility/utility";

const categoryFields = [
    { key: "goal_name" },
    { key: "prime_category" },
    { key: "category", label: "Secondary category" },
    { key: "sub_category" },
    // { key: "vendor_name" },
    { key: "opportunity", label: "Opportunity (%)" },
    { key: "goal", label: "Goal (%)" },
    { key: "created_at" },
    {
        key: "action",
        label: "Action",
        _style: "min-width:7rem",
        sorter: false,
        filter: false,
    },
];

export default {
    name: "Category_Opportunity",
    data() {
        return {
            currentItems: [],
            categoryFields,
            categoryOpportunity: this.getEmptyForm(),
            categoryOpportunityList: [],
            filteredCategoryOpportunityList: [],
            chooseFileTypeModal: false,

            selectedItem: "",
            selectedIndex: 0,

            error: { enable: false, message: "" },
            success: { enable: false, message: "" },

            addModal: false,
            importModal: false,
            update: false,
            clientOptions: storeData.clientList,
            clientFilter: "All",
            isAdmin: storeData.currentUserDetails.role.name,
            clientList: storeData.clientList,
            spinner: false,

            // options
            primeCategoryOptions: [],
            secondaryCategoryOptions: [],
            subCategoryOptions: [],

            limit: 10,
            offset: 0,
            pageCount: 0,

            searchVal: "",
        };
    },
    mixins: [validationMixin],
    validations() {
        let validation = {
            categoryOpportunity: {
                goal_name: {
                    required,
                    isValid: helpers.regex(
                        "isAddress1Valid",
                        /^[A-Za-z0-9-_]+(?: +[A-Za-z0-9-_]+)*$/i
                    ),
                },
                goal: {
                    required,
                    isValidOpportunity(value) {
                        if (
                            value.toString()[0] === "0" &&
                            value.toString()[1] !== "."
                        )
                            return false;
                        else if (value <= 100 && value > 0) return true;
                        return false;
                    },
                },
                opportunity: {},
                client_id: { required },
                prime_category: { required },
                category: {},
                sub_category: {},
                created_at: {
                    required,
                    isValid(date) {
                        if (new Date(date) > new Date()) return false;
                        else return true;
                    },
                },
            },
        };

        if (!this.isClientUser)
            validation.categoryOpportunity.opportunity = {
                required,
                isValidOpportunity(value) {
                    if (
                        value.toString()[0] === "0" &&
                        value.toString()[1] !== "."
                    )
                        return false;
                    else if (value <= 100 && value > 0) return true;
                    return false;
                },
            };

        return validation;
    },
    computed: {
        formString() {
            return JSON.stringify(this.categoryOpportunity, null, 2);
        },
        isValid() {
            return !this.$v.categoryOpportunity.$invalid;
        },
        isDirty() {
            return this.$v.categoryOpportunity.$anyDirty;
        },
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
        getPrimeCategories() {
            let primeCategories = [];
            for (const el of storeData.primeCategories) {
                primeCategories.push({
                    label: el.name,
                    value: el.id,
                });
            }
            return primeCategories;
        },
        isClientUser() {
            return storeData.currentUserDetails.role.name === "client_user";
        },
    },
    watch: {
        searchVal() {
            if (this.searchVal != "") {
                this.offset = 0;
                this.categoryOpportunity = [];
                this.getCategoryOpportunity(this.clientFilter);
            } else {
                this.offset = 0;
                this.categoryOpportunity = [];
                this.getCategoryOpportunity(this.clientFilter);
            }
        },
        clientFilter() {
            this.getCategoryOpportunity(this.clientFilter);
        },
    },
    methods: {
        setCurrentItems(val) {
            this.currentItems = val;
        },
        checkIfValid(fieldName) {
            const field = this.$v.categoryOpportunity[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },

        validate() {
            this.$v.$touch();
        },

        // Form Reset
        reset() {
            if (document.getElementById("client"))
                document.getElementById("client").selectedIndex = 0;
            if (document.getElementById("prime-category"))
                document.getElementById("prime-category").selectedIndex = 0;
            if (document.getElementById("secondary-category"))
                document.getElementById("secondary-category").selectedIndex = 0;
            if (document.getElementById("sub-category"))
                document.getElementById("sub-category").selectedIndex = 0;

            this.categoryOpportunity = this.getEmptyForm();
            this.$v.$reset();

            this.update = false;
        },

        // Form Data Empty
        getEmptyForm() {
            return {
                goal_name: "",
                opportunity: 0,
                goal: 0,
                prime_category: null,
                category: null,
                sub_category: null,
                client_id: storeData?.currentUserDetails?.client_id,
                created_at: _.getCurrentDate(),
            };
        },
        handlePrimeSelect() {
            // reset options
            this.secondaryCategoryOptions = [];
            this.subCategoryOptions = [];

            if (!this.update) {
                this.categoryOpportunity.category = null;
                this.categoryOpportunity.sub_category = null;
            }

            let primeCategory = this.categoryOpportunity.prime_category;
            if (primeCategory) {
                for (const el of storeData.categories) {
                    if (el.prime_category === primeCategory)
                        this.secondaryCategoryOptions.push({
                            label: el.name,
                            value: el.id,
                        });
                }
            }

            if (document.getElementById(`secondary-category`))
                document.getElementById(`secondary-category`).selectedIndex = 0;
            if (document.getElementById(`sub-category`))
                document.getElementById(`sub-category`).selectedIndex = 0;

            this.$v.categoryOpportunity.category.$reset();
            this.$v.categoryOpportunity.sub_category.$reset();
        },
        handleSecondarySelect() {
            // reset options
            this.subCategoryOptions = [];
            if (!this.update) {
                this.categoryOpportunity.sub_category = null;
            }

            let secondaryCategory = this.categoryOpportunity.category;
            if (secondaryCategory) {
                for (const el of storeData.subCategories) {
                    if (el.secondary_category === secondaryCategory)
                        this.subCategoryOptions.push({
                            label: el.name,
                            value: el.id,
                        });
                }
            }
            if (document.getElementById(`sub-category`))
                document.getElementById(`sub-category`).selectedIndex = 0;

            this.$v.categoryOpportunity.sub_category.$reset();
        },
        editCategoryOpportunity(item, index) {
            this.update = true;
            this.addModal = true;
            delete item.prime_category_master;
            delete item.category_master;
            delete item.sub_category_master;
            delete item.vendor_name;
            delete item.client;
            delete item.__typename;
            this.categoryOpportunity = { ...item };

            this.handlePrimeSelect();
            this.handleSecondarySelect();
        },
        deleteOpportunity(item, index) {
            this.selectedItem = { ...item };
            this.selectedIndex = index;
            this.chooseFileTypeModal = true;
        },
        saveCategoryOpportunity() {
            delete this.categoryOpportunity
                .spendmd_db_category_wise_opportunity;
            this.validate();
            if (this.isValid) {
                this.$apollo
                    .mutate({
                        mutation: INSERT_CATEGORY_WISE_OPPORTUNITY,
                        variables: {
                            ...this.categoryOpportunity,
                        },
                    })
                    .then((res) => {
                        const result =
                            res?.data
                                ?.insert_spendmd_db_category_wise_opportunity
                                ?.returning;
                        if (result && result[0].id > 0) {
                            this.success.enable = true;
                            this.success.message =
                                "Opportunity added successfully!!";
                            this.getCategoryOpportunity();
                        }
                    })
                    .catch((err) => {
                        this.error.enable = true;
                        this.error.message = "Opportunity failed to add!!";
                        console.log(err);
                    });
                this.addModal = false;
            }
        },
        updateCategoryOpportunity() {
            this.validate();
            if (this.isValid) {
                this.$apollo
                    .mutate({
                        mutation: UPDATE_CATEGORY_WISE_OPPORTUNITY,
                        variables: this.categoryOpportunity,
                    })
                    .then((res) => {
                        const result =
                            res?.data
                                ?.update_spendmd_db_category_wise_opportunity
                                ?.returning;

                        if (result && result[0].id > 0) {
                            this.success.enable = true;
                            this.success.message =
                                "Opportunity updated successfully!!";
                            this.getCategoryOpportunity();
                        }

                        this.filteredCategoryOpportunityList = [];
                        this.categoryOpportunityList = [];
                    })
                    .catch((err) => {
                        console.log(err);
                        this.error.enable = true;
                        this.error.message = "Opportunity failed to add!!";
                    });
                this.addModal = false;
                this.update = false;
            }
        },
        handleDeleteOpportunity() {
            this.$apollo
                .mutate({
                    mutation: DELETE_CATEGORY_WISE_OPPORTUITY,
                    variables: { id: this.selectedItem.id },
                })
                .then((res) => {
                    const result =
                        res?.data?.delete_spendmd_db_category_wise_opportunity
                            ?.returning;
                    if (result && result[0].id > 0) {
                        this.success.enable = true;
                        this.success.message =
                            "Opportunity deleted successfully!!";
                        this.getCategoryOpportunity();
                    }
                })
                .catch((err) => {
                    this.success.enable = true;
                    this.success.message = "Opportunity failed to delete!!";
                    console.log(err);
                });
            this.chooseFileTypeModal = false;
        },
        getCategoryOpportunity(clientId = null) {
            this.spinner = true;

            if (clientId === "All") {
                clientId = null;
            }

            this.$apollo
                .mutate({
                    mutation: GET_CATEGORY_WISE_OPPORTUNITY,
                    variables: {
                        client_id: clientId,
                        limit: this.limit,
                        offset: this.offset,
                        search:
                            this.searchVal !== ""
                                ? `%%${this.searchVal.trim()}%%`
                                : null,
                    },
                })
                .then((res) => {
                    const result =
                        res?.data?.spendmd_db_category_wise_opportunity;
                    this.categoryOpportunityList = [];
                    if (result && result.length > 0) {
                        this.categoryOpportunityList = result;
                        this.filteredCategoryOpportunityList = [
                            ...this.categoryOpportunityList,
                        ];
                    } else {
                        this.filteredCategoryOpportunityList = [];
                    }

                    this.pageCount =
                        Math.ceil(
                            res?.data
                                ?.spendmd_db_category_wise_opportunity_aggregate
                                ?.aggregate?.count / this.limit
                        ) || 0;

                    this.spinner = false;
                })
                .catch((err) => {
                    this.spinner = false;
                    console.log(err);
                });
        },
        getPreviousPage() {
            this.offset -= this.limit;
            this.getCategoryOpportunity(this.clientFilter);
        },
        getNextPage() {
            this.offset += this.limit;
            this.getCategoryOpportunity(this.clientFilter);
        },
    },

    beforeMount() {
        this.clientOptions = this.clientOptions.filter(
            (item) => item.value !== "All"
        );
        if (
            storeData.primeCategories.length > 0 &&
            storeData.primeCategories.length
        ) {
            this.prime = [];
            for (const el of storeData.primeCategories) {
                this.prime.push({
                    label: el.name,
                    value: el.id,
                });
            }
        }

        if (
            this.categoryFields.filter((el) => el.key === "client_name")
                .length == 0
        ) {
            if (storeData?.currentUserDetails?.role?.name === "sys_admin" || storeData?.currentUserDetails?.role?.name === "group_admin") {
                // add client name
                this.categoryFields.splice(this.categoryFields.length - 1, 0, {
                    key: "client_name",
                });
            }
        }
        this.getCategoryOpportunity();

        this.primeCategoryOptions = this.getPrimeCategories;

        if (this.isClientUser) {
            this.categoryFields = [
                { key: "goal_name" },
                { key: "prime_category" },
                { key: "category", label: "Secondary category" },
                { key: "sub_category" },
                { key: "goal", label: "Goal (%)" },
                { key: "created_at" },
                {
                    key: "action",
                    label: "Action",
                    _style: "min-width:7rem",
                    sorter: false,
                    filter: false,
                },
            ];
        } else if (this.isSysAdmin || this.isGroupAdmin) {
            this.categoryFields = [
                { key: "goal_name" },
                { key: "prime_category" },
                { key: "category", label: "Secondary category" },
                { key: "sub_category" },
                // { key: "vendor_name" },
                { key: "opportunity", label: "Opportunity (%)" },
                { key: "goal", label: "Goal (%)" },
                { key: "created_at" },
                { key: "client_name" },
                {
                    key: "action",
                    label: "Action",
                    _style: "min-width:7rem",
                    sorter: false,
                    filter: false,
                },
            ];
        } else {
            this.categoryFields = [
                { key: "goal_name" },
                { key: "prime_category" },
                { key: "category", label: "Secondary category" },
                { key: "sub_category" },
                // { key: "vendor_name" },
                { key: "opportunity", label: "Opportunity (%)" },
                { key: "goal", label: "Goal (%)" },
                { key: "created_at" },
                {
                    key: "action",
                    label: "Action",
                    _style: "min-width:7rem",
                    sorter: false,
                    filter: false,
                },
            ];
        }
    },
};
</script>

<style scoped>
hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.add-btn-top {
    margin-top: 1.9rem !important;
}
.add-btn {
    margin-top: 0.15rem;
}
.disable-add-btn {
    display: none;
}
.validStyle {
    border-color: #2eb85c;
}
.validStyle:focus {
    box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.25);
}
.invalidStyle {
    border-color: #e55353;
}
.invalidStyle:focus {
    box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.25);
}
.hideCustomField {
    display: none;
}
ul {
    display: inline-block;
    list-style-type: none;
}
#style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #555;
}

.scrollbar {
    height: 150px;
    overflow-y: scroll;
}

.force-overflow {
    min-height: 70px;
}
.clientfilter {
    padding: 0px;
}
</style>
